export const CMS_FAQS_ENDPOINT =
  '/items/energy5_faqs_sections?fields[]=*&fields[]=items.*&sort=-project';
export const CMS_FAQS_ABOUT_US_ENDPOINT =
  '/items/evc_pages?fields[]=*&fields[]=faqs.*&filter[name][_eq]%=about-us';
export const CMS_PARTNERS_ENDPOINT = '/items/energy5_partners';
export const CMS_STATE_TAXES_ENDPOINT = '/items/energy5_state_taxes';
export const CMS_LED_TERMS_OF_SERVICE_ENDPOINT = '/items/energy5_led_terms_of_service';

